import React from 'react';
import { DurationTicker } from 'components/DurationTicker';
import { CustomClockRegular } from 'components/CustomClockRegular';
import { Subtitle } from 'pages/Machine/MachineMainWrapper/styled';
import {
  DURATION_FORMAT,
  DURATION_OPTIONS,
} from 'pages/Machine/Tabs/constants';

const FAIWaitingTimer = ({ startDate }) => {
  if (!startDate) return null;
  return (
    <Subtitle>
      <CustomClockRegular
        autoPlay
        autoPlayMinuteInterval={100}
        autoPlayMinuteStep={1}
      />
      <DurationTicker
        startDate={startDate}
        format={DURATION_FORMAT}
        formatOptions={{ ...DURATION_OPTIONS, trim: 'small' }}
      />
    </Subtitle>
  );
};

export { FAIWaitingTimer };
